import { CardOrder } from '@/entities/profile-page/historyOrders/CardOrder/ui/CardOrder'
import './ui/CardOrder.scss'
export default CardOrder
